/**
 * TanStack Query hooks for `link-tester`. Thin wrappers over ./api.
 */
import {
	useMutation,
	type UseMutationResult,
} from "@tanstack/react-query";
import { toast } from "sonner";
import {
	testLink,
	type TestLinkBody,
	type TestLinkResponse,
} from "./api";

export function useLinkTest(): UseMutationResult<TestLinkResponse, Error, TestLinkBody> {
	return useMutation({
		mutationFn: testLink,
		onSuccess: (data) => {
			toast.success(
				`Traced ${data.hop_count} hop${data.hop_count === 1 ? "" : "s"} in ${data.total_latency_ms}ms`,
			);
		},
		onError: (err) => {
			toast.error(err.message || "Link test failed");
		},
	});
}
